// extracted by mini-css-extract-plugin
export var deleteModal = "_jc-0";